import React, { useState } from 'react';
import './Apply.css';
import { collection, addDoc } from "firebase/firestore";
import { db } from '../firebase';
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

const Apply = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    age: '',
    voicePart: '',
    motivation: '',
    videoFile: null,
  });

  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  const [statusEmail, setStatusEmail] = useState('');
  const [applicationStatus, setApplicationStatus] = useState(null);
  const [statusChecked, setStatusChecked] = useState(false);

  const voiceParts = ['Soprano', 'Alto', 'Tenor', 'Bass'];

  const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email.trim())) {
      newErrors.email = 'Email is invalid';
    }
    if (!formData.age || isNaN(formData.age) || formData.age < 10 || formData.age > 30) {
      newErrors.age = 'Age must be a number between 10 and 30';
    }
    if (!formData.voicePart) newErrors.voicePart = 'Please select a voice part';
    if (!formData.motivation.trim()) newErrors.motivation = 'Please provide a motivation message';
    if (!formData.videoFile) newErrors.videoFile = 'Please upload a video file';
    return newErrors;
  };

  const handleChange = e => {
    setFormData({...formData, [e.target.name]: e.target.value});
  };

  const handleFileChange = e => {
    setFormData({...formData, videoFile: e.target.files[0]});
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length === 0) {
      try {
        const storage = getStorage();
        const videoRef = ref(storage, `videos/${formData.videoFile.name}_${Date.now()}`);
        await uploadBytes(videoRef, formData.videoFile);
        const videoURL = await getDownloadURL(videoRef);

        const { videoFile, ...appData } = formData;
        const applicationData = { ...appData, videoURL };

        const docRef = await addDoc(collection(db, "applications"), applicationData);

        setSubmitted(true);
        setFormData({
          name: '',
          email: '',
          age: '',
          voicePart: '',
          motivation: '',
          videoFile: null,
        });
        setErrors({});
      } catch (error) {
        console.error('Error submitting application:', error);
        alert('Error submitting application');
        setSubmitted(false);
      }
    } else {
      setErrors(validationErrors);
      setSubmitted(false);
    }
  };

  const handleStatusEmailChange = e => {
    setStatusEmail(e.target.value);
  };

  const checkApplicationStatus = async e => {
    e.preventDefault();
    try {
    const response = await fetch(`${backendUrl}/api/applicants?email=${encodeURIComponent(statusEmail)}`, {
      headers: {
        Authorization: 'Bearer admin123',
      },
    });
      if (!response.ok) {
        throw new Error('Failed to fetch application status');
      }
      const data = await response.json();
      if (data.length === 0) {
        setApplicationStatus('No application found for this email.');
      } else {
        setApplicationStatus(data[0].status || 'Pending');
      }
    } catch (error) {
      setApplicationStatus('Error fetching status.');
      console.error(error);
    }
    setStatusChecked(true);
  };

  return (
    <section className="apply">
      <h2>Apply to Join the Choir</h2>
      {submitted && <div className="success-message">Thank you for your application! We will get back to you soon.</div>}
      <form onSubmit={handleSubmit} noValidate>
        <label>
          Full Name:
          <input type="text" name="name" value={formData.name} onChange={handleChange} />
          {errors.name && <span className="error">{errors.name}</span>}
        </label>
        <label>
          Email Address:
          <input type="email" name="email" value={formData.email} onChange={handleChange} />
          {errors.email && <span className="error">{errors.email}</span>}
        </label>
        <label>
          Age:
          <input type="number" name="age" value={formData.age} onChange={handleChange} />
          {errors.age && <span className="error">{errors.age}</span>}
        </label>
        <label>
          Voice Part:
          <select name="voicePart" value={formData.voicePart} onChange={handleChange}>
            <option value="">-- Select --</option>
            {voiceParts.map(part => (
              <option key={part} value={part}>{part}</option>
            ))}
          </select>
          {errors.voicePart && <span className="error">{errors.voicePart}</span>}
        </label>
        <label>
          Why do you want to join the choir?
          <textarea name="motivation" value={formData.motivation} onChange={handleChange} rows="4" />
          {errors.motivation && <span className="error">{errors.motivation}</span>}
        </label>
        <label>
          Upload Video (max 30 Seconds):
          <input type="file" accept="video/*" onChange={handleFileChange} />
          {errors.videoFile && <span className="error">{errors.videoFile}</span>}
        </label>
        <button type="submit">Submit Application</button>
      </form>

      <hr />

      <h2>Check Application Status</h2>
      <form onSubmit={checkApplicationStatus} noValidate>
        <label>
          Enter your email address:
          <input type="email" value={statusEmail} onChange={handleStatusEmailChange} required />
        </label>
        <button type="submit">Check Status</button>
      </form>
      {statusChecked && (
        <div className="status-result">
          <strong>Status: </strong>{applicationStatus}
        </div>
      )}
    </section>
  );
};

export default Apply;